import { render, staticRenderFns } from "./BaseRateInput.vue?vue&type=template&id=0904cb80"
import script from "./BaseRateInput.vue?vue&type=script&lang=js"
export * from "./BaseRateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports